import { render, staticRenderFns } from "./EntityNotesPane.vue?vue&type=template&id=4a1c6744&"
import script from "./EntityNotesPane.vue?vue&type=script&lang=js&"
export * from "./EntityNotesPane.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports